import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import HttpClient from '../../../utils/HttpClient';
import PasswordValidation from '../Forms/PasswordValidation';
import './form.css'

export const FifthForm = ({ onNext, onBack, formFifthData, setformFifthData, location, formThreeData }) => {
    const [checkProfile, setcheckProfile] = useState("")
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onNext();
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setformFifthData(prev => ({ ...prev, [name]: value }));
        liveCheck()
    }

    const liveCheck = async () => {
        const profileLink = `${process.env.REACT_APP_FRONTEND_URL}/Memberinvitation/` + formFifthData.userName;
        const data = {
            "userLink": profileLink,
            "emailId": formThreeData.emailId
        }
        // const res = await HttpClient.requestData("check-profile-link", "POST", data)
        const res = await HttpClient.requestData("check-link-availability", "POST", data)
        if (res && res?.status) {
            setcheckProfile("Available ✅")
        } else {
            setcheckProfile("Not Available ❌")
        }
    }

    useEffect(() => {
        liveCheck()
    }, [formFifthData.userName])


    return (
        <form >
            <div className="row">
                <div className="col-md-12 mt-3 ">
                    <label >Profile URL:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="userName"
                        name="userName"
                        value={formFifthData.userName}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                        readOnly={location?.state}
                    />
                    <span className='p-2 mt-2'>{checkProfile}</span>
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >User Name:<span className="text-danger">&nbsp;</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="userName"
                        name="userName"
                        value={formThreeData.emailId}
                        // onChange={handleChange}
                        autoComplete="off"
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    {location?.state ? "" : <label >Password:<span className="text-danger">&nbsp;*</span></label>}
                    {location?.state ? "" : <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="password"
                        name="password"
                        value={formFifthData.password}
                        onChange={handleChange}
                        required
                    />
                    }
                    <div
                        className="show-icon-img"
                        onClick={() => setShowPassword(!showPassword)} // Toggle on click
                        style={{ cursor: "pointer" }}
                    >
                        <i
                            className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"
                                }`}
                        ></i>
                    </div>
                    <PasswordValidation password={formFifthData.password} />
                </div>

            </div>
            {/* Your form fields for the second step */}
            <Button onClick={onBack} variant="contained" className='mx-2 mt-2'>
                Back
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary" className='mx-2 mt-2'>
                Next
            </Button>
        </form>
    )
}
